import { useEffect, useRef } from "react";
import { PostHogEvents, useTrackEvent } from "@/lib/posthog-events";
import { BackButton } from "./back-button";
import { MagicMomentMessageEditor } from "./magic-moment-message-editor";
import { useMagicMomentStore } from "./use-magic-moment-store";

interface MagicMomentDrawerProps {
  teenGender: "male" | "female" | null;
  teenId?: string | null;
  onInsertToChat?: (text: string) => void;
}

export function MagicMomentDrawer({
  teenGender,
  teenId,
  onInsertToChat,
}: MagicMomentDrawerProps) {
  const { track } = useTrackEvent();
  const viewTracked = useRef(false);
  const goBack = useMagicMomentStore((s) => s.goBack);

  useEffect(() => {
    if (!viewTracked.current) {
      viewTracked.current = true;
      track(PostHogEvents.DAY2_MAGIC_MOMENT_VIEW, {
        teen_id: teenId,
        template_variant: teenGender,
      });
    }
  }, []);

  const handleBack = () => {
    track(PostHogEvents.DAY2_MAGIC_MOMENT_BACK, { teen_id: teenId });
    goBack();
  };

  return (
    <div className="rounded-t-2xl border-x border-t border-surfaces-z4 bg-surfaces-z3 px-4 pb-4 pt-4">
      <BackButton onClick={handleBack} />
      <div className="flex flex-col gap-1">
        <h3 className="text-base font-bold leading-5 tracking-[-0.16px] text-text-primary">
          Magic moment
        </h3>
        <p className="text-sm leading-5 text-text-secondary">
          One thoughtful message can make a teen feel really seen. Use this as a
          starting point and make it yours.
        </p>
      </div>
      <div className="mt-2 flex flex-col gap-3">
        <MagicMomentMessageEditor
          teenGender={teenGender}
          onInsertToChat={onInsertToChat}
          insertClassName="mt-0 text-[14px] font-bold leading-[1.4] text-[#1f1e1d] hover:text-[#58534c]"
        />
      </div>
    </div>
  );
}
